module.exports = __webpack_public_path__ + "media/liveness-failed.8a994505.mp3";